import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import { RiGovernmentLine } from "react-icons/ri";
import { TbHexagonalPyramid } from "react-icons/tb";
import { MdOutlineEventAvailable } from "react-icons/md";
import { FaRegCalendarCheck, FaEye, FaLanguage, FaCalendarAlt} from "react-icons/fa";
import { MdOutlineManageHistory } from "react-icons/md";
import { IoCreateSharp } from "react-icons/io5";
import { MdOutlineManageAccounts } from "react-icons/md";
import { IoIosAddCircle } from "react-icons/io";
import { MdAssignmentAdd } from "react-icons/md";
import { BsPeopleFill } from "react-icons/bs";
import { FaListAlt } from "react-icons/fa";
import Langfield from "../../assets/Json/dashboardJson.json";
import { useSelector } from 'react-redux';
import { GiTurban } from "react-icons/gi";
import { FaRecycle } from "react-icons/fa";


function SideBar({
  index, role = 2
}) {
  // const [langSelected2, setLangSelected2 ] =React.useState ('en-IN');
  
  // const langSelected = useSelector((store) => store.lang.selectedLang)
   const langSelected2 = useSelector(state => state.auth?.user?.lang) || 'en-IN';
   const translations = Langfield[langSelected2] || Langfield['en-IN'];
  // useEffect(() => {
  //   // const userData = JSON.parse(localStorage.getItem('user'));
  //   setLangSelected2(langSelected);
  // }, [langSelected]);

  // const [storeLang, setStoreLang] = useState('en-IN');
  const defaultTranslations = Langfield['en-IN'] || {};
  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== 'object' || translations === null) {
        return defaultTranslations[key] || key.replace(/_/g, ' '); // Use English fallback if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== 'string') {
        return key; // Return the value as is if key is not a string
    }

    return translations[key] ?? defaultTranslations[key] ?? key.replace(/_/g, ' '); // Use current locale, fallback to English, or show a readable key
};


  return (
    <div className="schlDashbrdLft">
      <ul>
        <li><Link to="/school/schooldashboard" className={`${index === 0 ? 'activeLnk' : ''}`}><RiGovernmentLine /> {translate("Dashboard")}</Link></li>
        {/* RAS Activities form & management removed — RAS 2025–26 submission is closed. */}
        <li><Link to="/school/createtheme" className={`${index === 1 ? 'activeLnk' : ''}`} ><IoCreateSharp />{translate("Create_Event")}</Link></li>
        <li><Link to="/school/eventmanagement" className={`${index === 2 ? 'activeLnk' : ''}`}><MdOutlineManageHistory />{translate("Event_Management")}</Link></li>
        {/* <li>
          <Link to="/school/VeerBalDiwas" className={`${index === 9 ? 'activeLnk' : ''}`}><GiTurban /> Veer Bal Diwas </Link>
          </li> */}
        <li><Link to="/school/eventlist" className={`${index === 3 ? 'activeLnk' : ''}`}><FaListAlt />{translate("Event_List")}</Link></li>
        {/* Swachhata Hi Seva: SWM Drive — student participation page (the brief + quiz open from there or the dashboard) */}
        <li><Link to="/school/swachhata-students" className={`${index === 10 ? 'activeLnk' : ''}`}><FaRecycle /> Swachhata Hi Seva</Link></li>
        <li><Link to="/school/ecocalendar" className={`${index === 4 ? 'activeLnk' : ''}`}><MdOutlineEventAvailable />{translate("Eco_Calender")}</Link></li>
      
          <li>
            <Link to="/school/event-assignment" className={`${index === 5 ? 'activeLnk' : ''}`}><MdAssignmentAdd />{translate("Event_Assignment")}</Link>
            <Link to="/school/faculty-manage" className={`${index === 7 ? 'activeLnk' : ''}`}><MdOutlineManageAccounts />{translate("Faculty_Management")}</Link>
            <Link to="/school/set-language" className={`${index === 6 ? 'activeLnk' : ''}`}><FaLanguage />{translate("Set-Language")}
           { langSelected2!=='en-IN' && <div style={{
            
              marginLeft:" 37px"
      
           }}>Set Language</div>} </Link>
            <Link to="/school/notification" className={`${index === 8 ? 'activeLnk' : ''}`}><BsPeopleFill />{translate("Collaboration")} </Link>
          </li>
         
          
        {/* <SelectLang /> */}
      </ul>
    </div>
  )
}

export default SideBar